import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "campaigns",
  "use": "campaigns-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"campaigns\">\n<title>campaign</title>\n<path d=\"M0 6.667h3.333v10h-3.333v-10zM5 6.667l15-6.667v20l-15-6.667v-6.667zM8.333 8.597v3.069l8.333 3.333v-10l-8.333 3.597z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol